/// <amd-module name="Repos/Discussion/Editor/Components/AddCommentButton" />
import * as React from "react";
import * as Resources from "Repos/Discussion/Editor/Resources";
import { Button } from "VSSUI/Button";
import { css } from "VSSUI/Util";
import { IAddCommentButtonProps } from "./AddCommentButton.Props";

export const AddCommentButton = (props: IAddCommentButtonProps): JSX.Element => {
    const { className, onClick, tooltipText } = props;
    return (
        <Button
            excludeFocusZone={false}
            className={css("repos-add-comment-button", className)}
            subtle={true}
            iconProps={{ iconName: "Comment" }}
            onClick={onClick}
            tooltipProps={{ text: tooltipText || Resources.AddCommentAtLineTooltipText }}
        />
    );
};
